import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";

// export function tambahPartner(data) {
//   Swal.fire({
//     title: "Loading ...",
//     didOpen() {
//       Swal.showLoading();
//     },
//     allowOutsideClick: false,
//     allowEscapeKey: false,
//     allowEnterKey: false,
//   });
//   baseAxios
//     .post("/webPartner/tambahPartner", data, {
//       headers: { token: localStorage.getItem("token") },
//     })
//     .then(async (respon) => {
//       if (respon.status === 200) {
//         Swal.fire({
//           title: respon.data.message,
//           icon: "success",
//           showConfirmButton: false,
//           timer: 1500,
//         }).then(() => {
//           window.location.reload();
//         });
//       } else {
//         Swal.fire({
//           title: respon.data.message,
//           icon: "error",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//       }
//     })
//     .catch(errorHandler);
// }

export async function getAllPerusahaan(dispatch, params = {}) {
  try {
    const response = await baseAxios.get("/webPerusahaan/getAllPerusahaan", {
      headers: { token: localStorage.getItem("token") },
      params,
    });
    if (dispatch) {
      dispatch({
        type: "SET_GETALL_PERUSAHAAN",
        data: response.data.data || response.data,
      });
    }
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function createPerusahaan(data) {
  try {
    return await baseAxios.post("/webPerusahaan/tambahPerusahaan", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function updatePerusahaan(data) {
  try {
    return await baseAxios.patch("/webPerusahaan/editPerusahaan", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function deletePerusahaan(data) {
  try {
    return await baseAxios.post("/webPerusahaan/deletePerusahaan", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function getAllClientMaster(params = {}) {
  try {
    return await baseAxios.get("/webClient/getAllClient", {
      headers: { token: localStorage.getItem("token") },
      params,
    });
  } catch (err) {
    return err.response;
  }
}

export async function createClientMaster(data) {
  try {
    return await baseAxios.post("/webClient/tambahClient", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function updateClientMaster(data) {
  try {
    return await baseAxios.patch("/webClient/editClient", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function deleteClientMaster(data) {
  try {
    return await baseAxios.post("/webClient/deleteClient", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function getAllCabangMaster(params = {}) {
  try {
    return await baseAxios.get("/webCabang/getAllCabang", {
      headers: { token: localStorage.getItem("token") },
      params,
    });
  } catch (err) {
    return err.response;
  }
}

export async function createCabangMaster(data) {
  try {
    return await baseAxios.post("/webCabang/tambahCabang", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function updateCabangMaster(data) {
  try {
    return await baseAxios.patch("/webCabang/editCabang", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}

export async function deleteCabangMaster(data) {
  try {
    return await baseAxios.post("/webCabang/deleteCabang", data, {
      headers: { token: localStorage.getItem("token") },
    });
  } catch (err) {
    return err.response;
  }
}
